module.exports = __webpack_public_path__ + "img/scad_foto.ce72513d.png";